import qs from 'qs'

import { ContactPerson } from '@modules-deprecated/app/contactPerson/types/contactPerson'

import { deleteRequest, getRequest, postRequest, putRequest } from '../utils'

interface ContactPersonsResponse {
  contactPersons: ContactPerson[]
}

export interface CreateContactPersonPayload {
  contactId: string
  name: string
  email?: string
  isPrimary?: boolean
}

export interface UpdateContactPersonPayload {
  name: string
  email?: string
  isPrimary?: boolean
}

export interface ContactPersonMutationResponse {
  contactPersons: ContactPerson[]
}

export interface FetchContactPersonsOptions {
  contactId: string
  q?: string
  page?: number
  pageSize?: number
}

export const fetchContactPersons = ({
  contactId,
  q,
  page,
  pageSize,
}: FetchContactPersonsOptions): Promise<ContactPersonsResponse> => {
  const queryParams = qs.stringify({
    ...(contactId ? { contactId } : {}),
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(q ? { q } : {}),
  })

  return getRequest(`/v2/contactPersons?${queryParams}`)
}

export const deleteContactPerson = (contactPersonId: string): Promise<void> =>
  deleteRequest(`/v2/contactPersons/${contactPersonId}`)

export const createContactPerson = (payload: CreateContactPersonPayload): Promise<ContactPersonMutationResponse> =>
  postRequest('/v2/contactPersons', { contactPerson: payload })

export interface UpdateContactPersonArgs {
  id: string
  payload: UpdateContactPersonPayload
}

export const updateContactPerson = (
  updateContactPersonArgs: UpdateContactPersonArgs,
): Promise<ContactPersonMutationResponse> => {
  const { id, payload } = updateContactPersonArgs
  return putRequest(`/v2/contactPersons/${id}`, { contactPerson: payload })
}
